import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../../assets/logo.webp";

const Header = ({ onContactClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <NavLink to="/" onClick={() => isMenuOpen && toggleMenu()}>
            <img src={logo} alt="Logo" className="logo-img" />
          </NavLink>
        </div>

        <nav className={`nav-links ${isMenuOpen ? "active" : ""}`}>
          <ul>
            <li>
              <NavLink
                to="/"
                onClick={toggleMenu}
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/why-choose-us"
                onClick={toggleMenu}
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                Why Choose Us
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/projects"
                onClick={toggleMenu}
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                Projects
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/our-location"
                onClick={toggleMenu}
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                Our Location
              </NavLink>
            </li>
            <li className="contact-button-wrapper">
              <button
                onClick={() => {
                  toggleMenu();
                  onContactClick();
                }}
                className="link-button"
              >
                Contact Us
              </button>
            </li>
          </ul>
        </nav>

        <div className="desktop-contact-button">
          <button onClick={onContactClick} className="link-button">
            Contact Us
          </button>
        </div>

        <div
          className={`hamburger ${isMenuOpen ? "open" : ""}`}
          onClick={toggleMenu}
        >
          <span className="bar top"></span>
          <span className="bar middle"></span>
          <span className="bar bottom"></span>
        </div>
      </div>
    </header>
  );
};

export default Header;
